import React, { useEffect } from 'react';
import { postApi } from '../../apiUtils';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { MaintenanceCostTypesForm } from '../../forms/maintenanceCostTypes/MaintenanceCostTypesForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { MaintenanceCostTypeInputs } from '../../types/maintenanceCost.types';
import { API_URL } from '../../utils/apiUrl';

export function MaintenanceCostTypesNew() {
  const { translate } = useTranslation();
  const transFormName = 'MaintenanceCostType.Create';
  const { startLoading, stopLoading } = useLoading();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'New maintenance cost type',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Maintenance cost types', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const formData: MaintenanceCostTypeInputs = {
    id: 0,
    name: '',
    sortOrder: 0,
    visible: true,
  };

  const onSubmit = async (e) => {
    if (e !== null) e.preventDefault();
    let isOk = false;
    startLoading();
    await postApi<MaintenanceCostTypeInputs>({
      url: API_URL.MAINTENANCE_COST_TYPE_POST,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
      },
    });
    stopLoading();
    return isOk;
  };

  return (
    <PageContentWrapper heading={translate!('New maintenance cost type', transFormName)}>
      <MaintenanceCostTypesForm onSubmit={onSubmit} formData={formData} />
    </PageContentWrapper>
  );
}

export default MaintenanceCostTypesNew;
